import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import styles from './PaymentInfo.module.scss';

const CN_PREFIX = 'payment-info';
const SAH_TRANS_PREFIX = 'booking_request.spotahome_booking_payment_info';
const LL_TRANS_PREFIX = 'booking_request.landlord_payments_timeline';
const TYPE_PERCENTAGE = 'percentage';
const PERCENTAGE_SYMBOL = '%';

export const getCn = element => styles[`${CN_PREFIX}__${element}`];

export const transLL = (key, params = null) =>
  trans(`${LL_TRANS_PREFIX}.${key}`, params);

export const transTT = (key, params = null) =>
  trans(`${SAH_TRANS_PREFIX}.${key}`, params);

export const discountedPrice = ({
  discountType,
  discountValue,
  currencyIsoCode
}) =>
  discountType === TYPE_PERCENTAGE
    ? `${discountValue} ${PERCENTAGE_SYMBOL}`
    : formatPrice(discountValue, currencyIsoCode);

export default {
  getCn,
  transLL,
  transTT,
  discountedPrice
};
